import { z } from "zod";
import { PaginationSchema } from "../../pagination/response/PaginationResponse";
import { BookingSchema } from "./ShowBookingResponse";

const GetAllBookingResponseSchema = z.object({
    success: z.boolean(),
    message: z.string(),
    code: z.number(),
    data: z.array(BookingSchema),
    pagination: z.nullable(PaginationSchema).optional(),
});

export { GetAllBookingResponseSchema }

export type BookingsResponse = z.infer<typeof GetAllBookingResponseSchema>;
export type Booking = z.infer<typeof BookingSchema>;
